import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../logo.png";

const FOTO_PROPIEDAD = "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80";

const FUENTE_DESTACADA = "'Outfit', system-ui, sans-serif";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

export default function Home() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const dots = {
    backgroundImage: "radial-gradient(circle, #111827 1.6px, transparent 1.6px)",
    backgroundSize: "12px 12px",
  };

  return (
    <div style={{ minHeight: "100vh", fontFamily: "system-ui, sans-serif", background: "#fff", display: "flex", flexDirection: "column" }}>

      {/* HEAD: LOGO + FRASE */}
      <section style={{ background: "#fff" }}>
        <div style={{
          position: "relative",
          padding: isMobile ? "20px 16px 4px" : "32px 24px 4px",
          display: "flex", justifyContent: "center", alignItems: "center", background: "#fff"
        }}>
          {!isMobile && (
            <div style={{ ...dots, position: "absolute", right: "24px", bottom: "16px", width: "150px", height: "70px", opacity: 0.85 }} />
          )}
          <img
            src={logo}
            alt="Confalonieri Propiedades"
            style={{ height: isMobile ? "60px" : "80px", position: "relative", zIndex: 1 }}
          />
        </div>
        <div style={{ padding: isMobile ? "0 16px 20px" : "0 24px 28px", textAlign: "center" }}>
          <p style={{
            fontSize: isMobile ? "15px" : "18px",
            color: "#4b5563", fontStyle: "italic",
            marginBottom: "6px", fontFamily: "Georgia, 'Times New Roman', serif",
            letterSpacing: "0.3px", lineHeight: 1.3,
          }}>
            Su confianza es nuestra prioridad y su satisfacción nuestro compromiso
          </p>
          <p style={{ fontSize: isMobile ? "11px" : "12px", color: "#9ca3af" }}>Chajarí · Entre Ríos · Argentina</p>
        </div>
      </section>

      {/* HERO */}
      <section style={{ position: "relative", overflow: "hidden" }}>

        {/* FONDO: foto de la casa */}
        <img
          src={FOTO_PROPIEDAD}
          alt=""
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        {/* OVERLAY */}
        <div style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.25)",
          zIndex: 1,
          pointerEvents: "none",
        }} />

        {/* GRID igual que antes pero sin foto agente */}
        <div style={{
          position: "relative",
          zIndex: 2,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1.05fr 1fr",
          minHeight: isMobile ? "auto" : "440px",
        }}>

          {!isMobile && (
            <div style={{ ...dots, position: "absolute", top: "22px", left: "22px", width: "150px", height: "90px", zIndex: 3, opacity: 0.6 }} />
          )}

          <div style={{
            background: "rgba(26, 158, 42, 0.78)",
            clipPath: isMobile ? "none" : "polygon(0 0, 100% 0, 78% 100%, 0 100%)",
            padding: isMobile ? "32px 24px" : "80px 60px 60px 56px",
            display: "flex",
            alignItems: "center",
            justifyContent: isMobile ? "center" : "flex-start",
            backdropFilter: "blur(1px)",
            width: isMobile ? "100%" : undefined,
          }}>
            <div style={{
              color: "#fff",
              textTransform: "uppercase",
              letterSpacing: "1px",
              lineHeight: "1.05",
              fontFamily: FUENTE_DESTACADA,
              display: "flex",
              flexDirection: "column",
              gap: isMobile ? "12px" : "16px",
              width: "100%",
            }}>

              {/* BOTÓN: Nuestro Catálogo */}
              <button
                onClick={() => navigate("/propiedades")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isMobile ? "center" : "space-between",
                  gap: "14px",
                  background: "rgba(255,255,255,0.12)",
                  border: "1.5px solid rgba(255,255,255,0.55)",
                  borderRadius: "12px",
                  padding: isMobile ? "12px 18px" : "14px 22px",
                  cursor: "pointer",
                  color: "#fff",
                  fontFamily: FUENTE_DESTACADA,
                  fontWeight: "800",
                  fontSize: isMobile ? "15px" : "17px",
                  maxWidth: "320px",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  transition: "background 0.2s, border-color 0.2s, transform 0.15s",
                  backdropFilter: "blur(4px)",
                  width: "auto",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.22)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.9)";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.12)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.55)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <span>Nuestro Catálogo</span>
                <span style={{ fontSize: isMobile ? "16px" : "20px", opacity: 0.8, fontWeight: "400", flexShrink: 0 }}>→</span>
              </button>

              {/* BOTÓN: La Empresa */}
              <button
                onClick={() => navigate("/sobre-nosotros")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isMobile ? "center" : "space-between",
                  gap: "14px",
                  background: "transparent",
                  border: "1.5px solid rgba(255,255,255,0.35)",
                  borderRadius: "12px",
                  padding: isMobile ? "10px 18px" : "12px 22px",
                  cursor: "pointer",
                  color: "rgba(255,255,255,0.88)",
                  fontFamily: FUENTE_DESTACADA,
                  fontWeight: "700",
                  fontSize: isMobile ? "13px" : "15px",
                  maxWidth: "320px",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  transition: "background 0.2s, border-color 0.2s, transform 0.15s, color 0.2s",
                  width: "auto",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.65)";
                  e.currentTarget.style.color = "#fff";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)";
                  e.currentTarget.style.color = "rgba(255,255,255,0.88)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <span>La Empresa</span>
                <span style={{ fontSize: isMobile ? "13px" : "16px", opacity: 0.7, fontWeight: "400", flexShrink: 0 }}>→</span>
              </button>

              {/* BOTÓN: Vendemos tu propiedad */}
              <button
                onClick={() => navigate("/vender")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isMobile ? "center" : "space-between",
                  gap: "10px",
                  background: "#fff",
                  border: "1.5px solid #fff",
                  borderRadius: "12px",
                  padding: isMobile ? "11px 18px" : "13px 22px",
                  cursor: "pointer",
                  color: "#1a9e2a",
                  fontFamily: FUENTE_DESTACADA,
                  fontWeight: "800",
                  fontSize: isMobile ? "13px" : "15px",
                  maxWidth: "320px",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  transition: "opacity 0.2s, transform 0.15s",
                  width: "auto",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = "0.88";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = "1";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <span>Vendemos tu propiedad</span>
              </button>

            </div>
          </div>

          {/* columna derecha vacía — se ve la casa de fondo */}
          <div />

        </div>
      </section>

      {/* CONTACTO */}
      <div style={{ padding: isMobile ? "28px 16px" : "40px", background: "#e0e0e0", flex: 1 }}>
        <h2 style={{ fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "4px", fontFamily: "Georgia, serif", textAlign: "center" }}>Encontranos</h2>
        <div style={{ width: "40px", height: "2px", background: "#111827", margin: "0 auto 28px", borderRadius: "2px" }} />

        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: isMobile ? "14px" : "24px",
          flexWrap: "wrap",
          marginBottom: "28px",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
        }}>
          {[
            { icon: "📍", titulo: "Sarmiento 2750", sub: "Chajarí, Entre Ríos", link: null },
            { icon: "📞", titulo: "(03456) 15458348", sub: "WhatsApp disponible", link: "https://wa.me/5493456458348" },
            { icon: "📸", titulo: "@confalonieri.propiedades", sub: "Instagram", link: "https://www.instagram.com/confalonieri.propiedades" },
          ].map((c) => (
            <div
              key={c.titulo}
              onClick={() => c.link && window.open(c.link, "_blank")}
              style={{
                textAlign: "center",
                background: "#fff",
                borderRadius: "14px",
                padding: "20px 28px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                minWidth: isMobile ? "85%" : "160px",
                cursor: c.link ? "pointer" : "default",
              }}
            >
              <div style={{ fontSize: "26px", marginBottom: "8px" }}>{c.icon}</div>
              <p style={{ fontSize: "13px", fontWeight: "700", color: "#374151", marginBottom: "2px" }}>{c.titulo}</p>
              <p style={{ fontSize: "11px", color: "#9ca3af" }}>{c.sub}</p>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center" }}>
          <button
            onClick={() => window.open("https://wa.me/5493456458348", "_blank")}
            style={{
              background: "#1a9e2a",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              padding: "13px 32px",
              fontWeight: "700",
              fontSize: "14px",
              cursor: "pointer",
              width: isMobile ? "100%" : "auto",
            }}
          >
            💬 Escribinos por WhatsApp
          </button>
        </div>
      </div>

      {/* FOOTER */}
      <footer style={{
        borderTop: "3px solid #1a9e2a",
        padding: isMobile ? "14px 16px" : "16px 24px",
        textAlign: "center",
        color: "#9ca3af",
        fontSize: isMobile ? "11px" : "12px",
        background: "#fff",
        lineHeight: 1.4,
      }}>
        © {new Date().getFullYear()} Confalonieri Propiedades · Sarmiento 2750, Chajarí · Todos los derechos reservados
      </footer>
    </div>
  );
}
